import { Editor, Page } from 'grapesjs';
import { UserWebsite } from '../types/UserWebsite';
import { getFontsCssRules } from './font.utils';
import { generateFormScript } from './formScript';

// Generate complete HTML document from editor
const generateHtmlFromEditorObject = (editor: Editor, userWebsiteObject?: UserWebsite | null) => {
  const html = editor.getHtml();

  const css = editor.getCss();

  const generateSeoMetaTags = (userWebsite?: UserWebsite | null) => {
    if (!userWebsite || !userWebsite.isSearchEngineVisible()) {
      return `<meta name="robots" content="noindex, nofollow">`;
    }

    return `<meta name="robots" content="index, follow">`;
  };

  return `<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>${userWebsiteObject?.title}</title>
    <meta name="description" content="${userWebsiteObject?.description}">
    ${generateSeoMetaTags(userWebsiteObject)}
    ${css ? `<style>${css}</style>` : ''}
    <style>${getFontsCssRules()}</style>
</head>
<body>
    ${html}
    <script>${generateFormScript()}</script>
</body>
</html>`;
};

// Official GrapesJS Studio SDK way to generate HTML for all pages
export const generateAllPagesHtml = (editor: Editor, userWebsiteObject?: UserWebsite | null) => {
  const pages = editor.Pages.getAll();
  const currentPage = editor.Pages.getSelected();
  const pagesHtml: Array<{
    id: string;
    name: string;
    html: string;
  }> = [];

  // Generate HTML for each page
  pages.forEach((page: Page) => {
    // Select the page temporarily to get its content
    editor.Pages.select(page);

    pagesHtml.push({
      id: page.getId(),
      name: page.getName(),
      html: generateHtmlFromEditorObject(editor, userWebsiteObject),
    });
  });

  // Restore the originally selected page
  if (currentPage) {
    editor.Pages.select(currentPage);
  }

  return pagesHtml;
};
